import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>ClearPath Digital</title>
        <meta property="og:title" content="ClearPath Digital" />
        <link rel="canonical" href="https://clearpathdigital.teleporthq.app/" />
      </Helmet>
      <Navigation></Navigation>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
section {
  padding: var(--spacing-4xl) 0;
  position: relative;
  overflow: hidden;
}
</style>`}
          ></Script>
        </div>
      </div>
      <main>
        <section className="hero-section">
          <video
            src="https://videos.pexels.com/video-files/6248580/6248580-hd_1280_720_25fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/6248580/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-bg-video"
          ></video>
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1 className="home-hero-title hero-title">
              We Build Websites That Turn Visitors Into High-Value Clients
            </h1>
            <p className="hero-subtitle home-hero-subtitle">
              High-performance website creation for ambitious SMEs, startups,
              and local businesses in France &amp; Luxembourg. No fluff, just
              results.
            </p>
            <div className="hero-cta-group">
              <Link to="/contact-book-a-call">
                <div className="home-thq-btn-elm1 btn btn-primary btn-lg">
                  <span>Book a free website strategy call</span>
                </div>
              </Link>
            </div>
            <div className="hero-trust-line">
              <div className="flex-row">
                <svg
                  fill="none"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
                <span>
                  Trusted by businesses across the EU to drive measurable growth
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="problem-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title home-section-title">
                Is Your Current Website Costing You Business?
              </h2>
              <p className="section-subtitle">
                Most business websites fail because they are built for
                &quot;design,&quot; not for sales. If you recognize these signs,
                it&apos;s time for a change.
              </p>
            </div>
            <div className="problem-grid">
              <div className="problem-card">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="#e74c3c"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <line x1="12" x2="12" y1="8" y2="12"></line>
                  <line x1="12" x2="12.01" y1="16" y2="16"></line>
                </svg>
                <h3 className="problem-card-title">Zero Lead Generation</h3>
                <p className="section-content">
                  Traffic arrives but never converts. Your site is a digital
                  brochure, not a sales asset.
                </p>
              </div>
              <div className="problem-card">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="#e74c3c"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                </svg>
                <h3 className="problem-card-title">Frustratingly Slow</h3>
                <p className="section-content">
                  40% of users leave if a site takes more than 3 seconds to
                  load. You&apos;re losing clients to speed.
                </p>
              </div>
              <div className="problem-card">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="#e74c3c"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle r="4" cx="9" cy="7"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <h3 className="problem-card-title">Low Professional Trust</h3>
                <p className="section-content">
                  An outdated or broken design tells potential clients that your
                  service might be outdated too.
                </p>
              </div>
              <div className="problem-card">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="#e74c3c"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <h3 className="problem-card-title">Confusing Messaging</h3>
                <p className="section-content">
                  If visitors can&apos;t tell what you do in 5 seconds, they
                  won&apos;t stick around to find out.
                </p>
              </div>
              <div className="problem-card">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="#e74c3c"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="5" y="2" rx="2" ry="2" width="14" height="20"></rect>
                  <line x1="12" x2="12.01" y1="18" y2="18"></line>
                </svg>
                <h3 className="problem-card-title">Mobile Nightmare</h3>
                <p className="section-content">
                  Over 60% of your traffic is on mobile. If your site
                  doesn&apos;t work there, it doesn&apos;t work at all.
                </p>
              </div>
              <div className="problem-card">
                <svg
                  fill="none"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  stroke="#e74c3c"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" x2="12" y1="22.08" y2="12"></line>
                </svg>
                <h3 className="problem-card-title">Invisible to Search</h3>
                <p className="section-content">
                  Bad technical foundations mean you&apos;ll never rank for the
                  keywords that actually bring revenue.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="solution-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title home-section-title">
                The Solution: Websites Built for Business Outcomes
              </h2>
              <p className="section-subtitle">
                We don&apos;t just &quot;design.&quot; We engineer digital sales
                machines that work for you 24/7.
              </p>
            </div>
            <div className="solution-grid">
              <div className="solution-item">
                <div className="solution-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                    <polyline points="16 7 22 7 22 13"></polyline>
                  </svg>
                </div>
                <h3 className="solution-item-title">
                  Conversion-First Strategy
                </h3>
                <p className="section-content">
                  Every pixel is placed with one goal: getting your visitors to
                  take the next step in your sales funnel.
                </p>
              </div>
              <div className="solution-item">
                <div className="solution-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                  </svg>
                </div>
                <h3 className="solution-item-title">Ultra-Fast Performance</h3>
                <p className="section-content">
                  We optimize for Core Web Vitals to ensure lightning-fast load
                  times that keep users engaged and Google happy.
                </p>
              </div>
              <div className="solution-item">
                <div className="solution-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="5"
                      y="2"
                      rx="2"
                      ry="2"
                      width="14"
                      height="20"
                    ></rect>
                    <line x1="12" x2="12.01" y1="18" y2="18"></line>
                  </svg>
                </div>
                <h3 className="solution-item-title">Mobile-First Experience</h3>
                <p className="section-content">
                  Seamlessly responsive layouts that provide a premium
                  experience on every device, from mobile to ultra-wide.
                </p>
              </div>
              <div className="solution-item">
                <div className="solution-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                </div>
                <h3 className="solution-item-title">Clear, Direct Messaging</h3>
                <p className="section-content">
                  Professional copywriting guidance that clarifies your value
                  proposition and eliminates visitor confusion.
                </p>
              </div>
              <div className="solution-item">
                <div className="solution-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="4"
                      rx="2"
                      ry="2"
                      width="18"
                      height="18"
                    ></rect>
                    <line x1="16" x2="16" y1="2" y2="6"></line>
                    <line x1="8" x2="8" y1="2" y2="6"></line>
                    <line x1="3" x2="21" y1="10" y2="10"></line>
                  </svg>
                </div>
                <h3 className="solution-item-title">
                  Integrated Booking Flows
                </h3>
                <p className="section-content">
                  Automation that lets clients book calls directly on your site,
                  syncing with your calendar instantly.
                </p>
              </div>
              <div className="solution-item">
                <div className="solution-icon-box">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  </svg>
                </div>
                <h3 className="solution-item-title">Trust-Building Design</h3>
                <p className="section-content">
                  High-authority visual identity that positions you as the
                  leader in your market from the first click.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="process-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title home-section-title">
                Our 3-Step Success System
              </h2>
              <p className="section-subtitle">
                A transparent, predictable journey from initial concept to a
                high-converting launch.
              </p>
            </div>
            <div className="process-steps">
              <div className="step-card">
                <div className="step-number">
                  <span>01</span>
                </div>
                <h3 className="step-title">Strategy &amp; Structure</h3>
                <ul className="step-list">
                  <li>
                    <span>Business goal alignment</span>
                  </li>
                  <li>
                    <span>Conversion map &amp; wireframes</span>
                  </li>
                  <li>
                    <span>Copywriting architecture</span>
                  </li>
                </ul>
              </div>
              <div className="step-arrow">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" x2="19" y1="12" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
              <div className="step-card">
                <div className="step-number">
                  <span>02</span>
                </div>
                <h3 className="step-title">Premium Design</h3>
                <ul className="step-list">
                  <li>
                    <span>Modern visual identity</span>
                  </li>
                  <li>
                    <span>Mobile-first development</span>
                  </li>
                  <li>
                    <span>Interactive user experience</span>
                  </li>
                </ul>
              </div>
              <div className="step-arrow">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" x2="19" y1="12" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
              <div className="step-card">
                <div className="step-number">
                  <span>03</span>
                </div>
                <h3 className="step-title">Conversion Launch</h3>
                <ul className="step-list">
                  <li>
                    <span>Speed &amp; SEO optimization</span>
                  </li>
                  <li>
                    <span>Lead flow testing</span>
                  </li>
                  <li>
                    <span>Final launch &amp; support</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="process-cta">
              <Link to="/contact-book-a-call">
                <div className="home-thq-btn-elm2 btn btn-secondary">
                  <span>Ready to start? Book your call</span>
                </div>
              </Link>
            </div>
          </div>
        </section>
        <section className="faq-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title home-section-title">
                Common Questions
              </h2>
              <p className="section-subtitle">
                Everything you need to know before we start building your sales
                asset.
              </p>
            </div>
            <div className="faq-accordion">
              <details className="faq-item">
                <summary className="faq-trigger">
                  <span>How long does the entire process take?</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="faq-icon"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </summary>
                <div className="faq-content">
                  <p className="section-content">
                    A standard high-conversion website typically takes 4 to 6
                    weeks from the initial strategy call to final launch. This
                    timeline ensures we don&apos;t rush the critical strategy
                    and testing phases.
                  </p>
                </div>
              </details>
              <details className="faq-item">
                <summary className="faq-trigger">
                  <span>Do you use generic templates?</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="faq-icon"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </summary>
                <div className="faq-content">
                  <p className="section-content">
                    No. Every business has unique goals. We build custom design
                    systems tailored specifically to your brand and conversion
                    requirements to ensure you stand out from competitors.
                  </p>
                </div>
              </details>
              <details className="faq-item">
                <summary className="faq-trigger">
                  <span>Will I be able to edit the content myself?</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="faq-icon"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </summary>
                <div className="faq-content">
                  <p className="section-content">
                    Absolutely. We build on user-friendly platforms and provide
                    a custom video walkthrough so you and your team can easily
                    update text, images, and blog posts without needing a
                    developer.
                  </p>
                </div>
              </details>
              <details className="faq-item">
                <summary className="faq-trigger">
                  <span>Is the website optimized for mobile and speed?</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="faq-icon"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </summary>
                <div className="faq-content">
                  <p className="section-content">
                    Yes, this is our core standard. Every site is built
                    mobile-first and optimized for maximum speed to ensure you
                    pass Google&apos;s Core Web Vitals and provide a seamless
                    user experience.
                  </p>
                </div>
              </details>
              <details className="faq-item">
                <summary className="faq-trigger">
                  <span>Do you offer ongoing maintenance and support?</span>
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="faq-icon"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </summary>
                <div className="faq-content">
                  <p className="section-content">
                    We provide 30 days of post-launch support for free. We also
                    offer monthly growth and maintenance packages to keep your
                    site secure, fast, and continuously optimized for
                    conversions.
                  </p>
                </div>
              </details>
            </div>
          </div>
        </section>
        <section className="final-cta-section">
          <div className="container">
            <div className="cta-card">
              <h2 className="section-title home-section-title">
                Ready to Transform Your Website Into a Sales Asset?
              </h2>
              <p className="section-subtitle">
                Stop losing clients to a slow, confusing website. Let&apos;s
                build a digital presence that reflects your authority.
              </p>
              <div className="cta-actions">
                <Link to="/contact-book-a-call">
                  <div className="home-thq-btn-elm3 btn btn-primary btn-xl">
                    <span>Book a free website strategy call</span>
                  </div>
                </Link>
              </div>
              <div className="cta-footer">
                <p className="section-content">
                  No obligation. Just professional advice on how to grow your
                  business online.
                </p>
                <a href="/privacy">
                  <div className="btn-sm btn-link">
                    <span>GDPR &amp; Data Privacy Policy</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="home-container5">
        <div className="home-container6">
          <Script
            html={`<style>
        @keyframes fadeIn {from {opacity: 0;
transform: translateY(20px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="home-container7">
        <div className="home-container8">
          <Script
            html={`<script defer data-name="conversion-enhancements">
(function(){
  // Handle smooth reveals for cards on scroll
  const observerOptions = {
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  document.querySelectorAll('.problem-card, .solution-item, .step-card, .trust-stat-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'all 0.6s ease-out';
    observer.observe(el);
  });

  // Simple FAQ interaction enhancement (optional, since details/summary is native)
  // Just ensuring only one accordion is open at a time for better focus
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    item.addEventListener('toggle', (e) => {
      if (item.open) {
        faqItems.forEach(otherItem => {
          if (otherItem !== item && otherItem.open) {
            otherItem.open = false;
          }
        });
      }
    });
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
